module.exports = __webpack_public_path__ + "static/media/l12_voice_five_v2.6f05e891.mp3";